import { useEffect, useState } from 'react';

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }

    const listener = () => setMatches(media.matches);
    media.addEventListener('change', listener);

    return () => media.removeEventListener('change', listener);
  }, [matches, query]);

  return matches;
}

type Query = 'up' | 'down' | 'between';
type Breakpoint = 'sm' | 'md' | 'lg' | 'xl' | '2xl';

const breakpoints: Record<Breakpoint, number> = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
};

export function useResponsive(
  query: Query,
  start: Breakpoint,
  end?: Breakpoint
): boolean {
  const min = breakpoints[start];
  const max = end ? breakpoints[end] - 0.02 : undefined;

  let mediaQuery = '';

  if (query === 'up') mediaQuery = `(min-width: ${min}px)`;
  if (query === 'down') mediaQuery = `(max-width: ${min}px)`;
  if (query === 'between' && max !== undefined) {
    mediaQuery = `(min-width: ${min}px) and (max-width: ${max}px)`;
  }

  return useMediaQuery(mediaQuery);
}
